
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Modal from "../miscellaneous/Modal/Modal";
import GettingStartedContent from "./Content/GettingStartedContent";
import {AddStaffMember, ConnectYourFirstClinic, ConnectYourFirstPlatform, ManageMyClinics, ManageServiceCalls, SetMyWorkingHours} from 'dictionaries/tours';
import { useDispatch, useSelector } from "react-redux";
import { setShowGettingStarted } from "store/auth-slice";
import { setGettingStartedState } from "store/tour-slice"
import { $t } from 'helpers/translator';

const GettingStarted = (props) => {
    const {userRole, userId} = props;
    const dispatch = useDispatch();
    const location = useLocation();
    const userGettingStarted = useSelector(state => state.auth.user.show_getting_started)        //from store
    const isShown = useSelector(state => state.tour.show_getting_started)        //from store
    const [showModal, setShowModal] = useState(false);
    const [gettingStarted, setGettingStarted] = useState(userGettingStarted);

    const content = {
        clinic: {
            role: 2,
            cards: [
                {
                    title: $t('global.gettingStarted.cards.connectYourPlatform.title'),
                    description: $t('global.gettingStarted.cards.connectYourPlatform.description'),
                    image: 'https://smartclinic-public.s3.eu-west-1.amazonaws.com/icons/monitor.png',
                    cta: $t('global.gettingStarted.cards.connectYourPlatform.cta'),
                    tour: ConnectYourFirstPlatform
                },
                {
                    title: $t('global.gettingStarted.cards.setWorkingHours.title'),
                    description: $t('global.gettingStarted.cards.setWorkingHours.description'),
                    image: 'https://smartclinic-public.s3.eu-west-1.amazonaws.com/icons/calendar.png',
                    cta: $t('global.gettingStarted.cards.setWorkingHours.cta'),
                    tour: SetMyWorkingHours
                },
                {
                    title: $t('global.gettingStarted.cards.addStaffMember.title'),
                    description: $t('global.gettingStarted.cards.addStaffMember.description'),
                    image: 'https://smartclinic-public.s3.eu-west-1.amazonaws.com/icons/online-meeting.png',
                    cta: $t('global.gettingStarted.cards.addStaffMember.cta'),
                    url: '/staff',
                    tour: AddStaffMember
                },
            ]
        },
        chain: {
            role: 3,
            cards: [
                {
                    title: $t('global.gettingStarted.cards.connectMyFirstClinic.title'),
                    description: $t('global.gettingStarted.cards.connectMyFirstClinic.description'),
                    image: 'https://smartclinic-public.s3.eu-west-1.amazonaws.com/icons/monitor.png',
                    cta: $t('global.gettingStarted.cards.connectMyFirstClinic.cta'),
                    tour: ConnectYourFirstClinic
                },
                {
                    title: $t('global.gettingStarted.cards.manageMyClinics.title'),
                    description: $t('global.gettingStarted.cards.manageMyClinics.description'),
                    image: 'https://smartclinic-public.s3.eu-west-1.amazonaws.com/icons/office.png',
                    cta: $t('global.gettingStarted.cards.manageMyClinics.cta'),
                    tour: ManageMyClinics
                },
                {
                    title: $t('global.gettingStarted.cards.setWorkingHours.title'),
                    description: $t('global.gettingStarted.cards.setWorkingHours.description'),
                    image: 'https://smartclinic-public.s3.eu-west-1.amazonaws.com/icons/calendar.png',
                    cta: $t('global.gettingStarted.cards.setWorkingHours.cta'),
                    tour: SetMyWorkingHours
                },
            ]
        },
        distributor: {
            role: 4,
            cards: [
                {
                    title: $t('global.gettingStarted.cards.manageServiceCalls.title'),
                    description: $t('global.gettingStarted.cards.manageServiceCalls.description'),
                    image: 'https://smartclinic-public.s3.eu-west-1.amazonaws.com/icons/announcement.png',
                    cta: $t('global.gettingStarted.cards.manageServiceCalls.cta'),
                    tour: ManageServiceCalls
                },
                {
                    title: $t('global.gettingStarted.cards.manageMyClinicsAndChains.title'),
                    description: $t('global.gettingStarted.cards.manageMyClinicsAndChains.description'),
                    image: 'https://smartclinic-public.s3.eu-west-1.amazonaws.com/icons/office.png',
                    cta: $t('global.gettingStarted.cards.manageMyClinicsAndChains.cta'),
                    tour: ManageMyClinics
                }
            ]
        },
    }

    useEffect(() => {
        if (location.pathname === "/dashboard" || location.pathname === "/") {
            if(shouldShow()) {
                if(showModal !== true) {
                    new Promise(resolve => setTimeout(resolve, 100)).then(() => {
                        setShowModal(true);
                    });
                }
            }
        } else {
            setShowModal(false);
        }
    }, [location])

    useEffect(() => {
         //console.log(isShown, showModal)

        if(isShown != showModal) {
            dispatch(setGettingStartedState(showModal));
        }
        if(showModal) {
            saveLastTimeSeen()
        }
    }, [showModal])

    useEffect(() => {
        //console.log('isShown does not equal showModal: ', isShown, showModal)
        if(isShown === true && showModal === false) {
           setShowModal(isShown);
        }
    }, [isShown])

    const onClose = (res) => {
        const currentValue = !gettingStarted;

        if(res?.closedByTourClick && gettingStarted === false) {
            deleteLastTimeSeen()
        }

        if(currentValue !== userGettingStarted) {
            // console.log('Updating show getting started');
            dispatch(setShowGettingStarted(currentValue));
        }

        setShowModal(false)
    }
    
    const getModal = () => {
        const getContent = Object.values(content).find(item => item.role === userRole);

        if(getContent) {
            return <>
            <Modal content={<GettingStartedContent onShowAgainStateChange={(state) => setGettingStarted(state)} showAgainValue={!gettingStarted} onClose={onClose} cards={getContent.cards} />}
                onClose={onClose}
                modalStyle={{
                    background: '#f4f3f6',
                    borderRadius: '10px',
                    padding: 0
                }}
                showCloseButton={false}
                visible={showModal} 
            />
        </>
        }
    }

    const saveLastTimeSeen = () => {
        const lastTimeSeen = new Date();
        localStorage.setItem('getting_started_last_seen', lastTimeSeen);
        localStorage.setItem('getting_started_last_user_id', userId);
    }

    const deleteLastTimeSeen = () => {
        localStorage.removeItem('getting_started_last_seen');
    }

    const shouldShow = () => {
        const lastTimeSeen = localStorage.getItem('getting_started_last_seen');
        const lastUserId = localStorage.getItem('getting_started_last_user_id') ? parseInt(localStorage.getItem('getting_started_last_user_id')) : null;
        const lastTimeSeenDate = lastTimeSeen ? new Date(lastTimeSeen) : null;
        const hasTimePassed = lastTimeSeenDate < new Date(new Date().setDate(new Date().getDate() - 1));
        //console.log(userGettingStarted, hasTimePassed, lastTimeSeenDate, lastUserId, userId);
        if(userGettingStarted && (lastTimeSeenDate === null || lastUserId !== userId || (hasTimePassed && lastUserId === userId))) {
            return true;
        }

        return false
    }

    return (<>
        {getModal()}
    </>)
}

export default GettingStarted;